module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAAXNSR0IArs4c6QAAAJ5JREFUGBljnLJs/7//DAxXuVmYnZLC7F4zAMG8VYdEv/75u4+RgUGbcfKy/ZcZ/v/XYWRkuMrFwuIIUvDtz5/9//8zaDMwMl5hAemECQDpQyAFQEkNkCRIDmgKxEiQJFgCyAeadgNomh3ISiaQAnyAEeQgmBUgnSDFIJNgbmJBkgQ78icLM+PfHz/3gRwJkmMBMWCqYd6cvu6oE0wRAH3fXPbF5CiiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon--close--grey.png
// module id = oIDH
// module chunks = 1